import V1 from './v1/NoteModuleV1'
import { IModule } from '@/contracts/core/module/interface/IModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'

export class NoteModuleProvider extends Provider<IModule> {
  realizations: Record<string, IModule> = {
    v1: V1(),
  }
}

const instance: { module: IModule | null } = { module: null }

export default function NoteModuleProviderModule (): IModule {
  const version = 'v1'

  if(!instance.module){
    instance.module = new NoteModuleProvider().module(version)
  }

  return instance.module
}
